import { render } from "./InitiativeComment.vue?vue&type=template&id=6c28a7eb&scoped=true"
import script from "./InitiativeComment.vue?vue&type=script&lang=js"
export * from "./InitiativeComment.vue?vue&type=script&lang=js"

import "./InitiativeComment.vue?vue&type=style&index=0&id=6c28a7eb&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c28a7eb"]])

export default __exports__